/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import liveSearchProductsButtons from './buttons.js'
import liveSearchProductsError from './error.js'
import liveSearchProductsEvents from './events.js'
import liveSearchProductsFilter from './filter.js'
import liveSearchProductsLayout from './layout.js'
import liveSearchProductsMapping from './mapping.js'
import liveSearchProductsObserver from './observer.js'
import liveSearchProductsAnimation from './animation.js'
import liveSearchProductsSlider from './slider.js'
import liveSearchProductsPages from './pages.js'
import liveSearchProductsRequest from './request.js'
import liveSearchProductsVisibility from './visibility.js'

const liveSearchProducts = {
    products: [],
    loadingPlaceholderSlots: [],
    loadingPlaceholderTimeoutId: null,
    productsInitialLoaded: false,
    productsLoading: true,
    productFetchErrorMessage: '',
    lastProductRequest: null,
    ...liveSearchProductsButtons,
    ...liveSearchProductsError,
    ...liveSearchProductsEvents,
    ...liveSearchProductsFilter,
    ...liveSearchProductsLayout,
    ...liveSearchProductsMapping,
    ...liveSearchProductsObserver,
    ...liveSearchProductsAnimation,
    ...liveSearchProductsSlider,
    ...liveSearchProductsVisibility,
    ...liveSearchProductsPages,
    ...liveSearchProductsRequest
}

export default liveSearchProducts
